import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "toss-return" }
const _hoisted_2 = { class: "toss-return__kicker" }
const _hoisted_3 = { class: "toss-return__message" }

import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { confirmTossPayment } from '@/api/mallOrder'


export default /*@__PURE__*/_defineComponent({
  __name: 'MallTossReturnPage',
  props: {
    outcome: {}
  },
  setup(__props: any) {

const props = __props

const route = useRoute()
const router = useRouter()
const message = ref(props.outcome === 'success' ? '결제를 확인하고 있습니다. 잠시만 기다려 주세요.' : '')
const orderCode = ref('')

const title = computed(() => (props.outcome === 'success' ? '결제를 확인하고 있습니다' : '결제가 끝나지 않았습니다'))

const orderPath = computed(() => (orderCode.value ? `/mall/orders/${orderCode.value}` : ''))

onMounted(async () => {
  if (props.outcome === 'fail') {
    const orderId = String(route.query.orderId || '')
    orderCode.value = orderId
    if (orderId) {
      router.replace({ path: `/mall/orders/${orderId}`, query: { pay: 'closed' } })
      return
    }
    message.value = String(route.query.message || '결제를 마치지 않았습니다. 주문에서 다시 결제할 수 있습니다.')
    return
  }

  const paymentKey = String(route.query.paymentKey || '')
  const orderId = String(route.query.orderId || '')
  const amount = Number(route.query.amount)
  orderCode.value = orderId

  if (!paymentKey || !orderId || !Number.isInteger(amount)) {
    message.value = '결제 정보가 없습니다. 주문에서 다시 시도해 주세요.'
    return
  }

  try {
    await confirmTossPayment(orderId, { paymentKey, amount })
    router.replace(`/mall/orders/${orderId}`)
  } catch (error) {
    message.value = error instanceof Error ? error.message : '결제 승인에 실패했습니다.'
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["toss-return__card", __props.outcome === 'fail' ? 'is-fail' : 'is-wait'])
    }, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(__props.outcome === 'success' ? '카드 · 간편결제' : '결제 중단'), 1),
      _createElementVNode("h1", null, _toDisplayString(title.value), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(message.value), 1),
      (orderPath.value)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            class: "toss-return__go",
            to: orderPath.value
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("주문에서 확인", -1)
            ]))]),
            _: 1
          }, 8, ["to"]))
        : (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            class: "toss-return__go",
            to: "/mall/cart"
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("장바구니로", -1)
            ]))]),
            _: 1
          }))
    ], 2)
  ]))
}
}

})